/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';

import { IconColorized, IconPaid, IconPremium, IconTop3 } from './icons';
import * as styles from './index.css';
import { trackClick, TrackingAction, TTrackingAction } from './tracking';

export interface IOfferValueAddedServices {
  isColorized: boolean;
  isPaid: boolean;
  isTop3: boolean;
  isPremium: boolean;
  isFree: boolean;
}

export interface IOfferValueAddedServicesProps {
  valueAddedServices: IOfferValueAddedServices | null;
  /** Флаг активности ML-ранжирования */
  isMlSearchEnabled: boolean;
}

interface IOtherValueAddedServicesEnabled {
  icon: string;
  link: string;
  title: string;
}

interface IMapValueAddedServicesKeysToString {
  [key: string]: {
    title: string;
    link: string;
  };
}

const mapValueAddedServicesKeysToString: IMapValueAddedServicesKeysToString = {
  isColorized: {
    link: '/promo/adv/#color',
    title: 'Выделение цветом',
  },
  isPaid: {
    link: '/help/add/paid/',
    title: 'Платное',
  },
  isPremium: {
    link: '/promo/adv/#premium',
    title: 'Премиум',
  },
  isTop3: {
    link: '/promo/adv/#top3',
    title: 'Топ-3',
  },
};

const mapValueAddedMLSearchServicesKeysToString: IMapValueAddedServicesKeysToString = {
  isColorized: {
    link: '/promo/adv/#color',
    title: 'Выделение цветом',
  },
  isPaid: {
    link: '/help/add/paid/',
    title: 'Платное',
  },
  isPremium: {
    link: '/promo/adv/#premium',
    title: 'Премиум',
  },
  isTop3: {
    link: '/promo/adv/#top3',
    title: 'Топ',
  },
};

export const getValueAddedServicesIcon = (name: string) => {
  switch (name) {
    case 'isColorized':
      return <IconColorized />;

    case 'isPaid':
      return <IconPaid />;

    case 'isTop3':
      return <IconTop3 />;

    case 'isPremium':
      return <IconPremium />;

    default:
      return '';
  }
};

export class OfferValueAddedServices extends React.Component<IOfferValueAddedServicesProps, {}> {
  public render() {
    if (!this.props.valueAddedServices) {
      return null;
    }

    return (
      <div className={styles['container']}>
        {this.getValueAddedServices().map((valueAddedServicesItem, index) => {
          return (
            <a
              key={`valueAddedServicesItem_${index}`}
              className={styles['vas_item']}
              href={valueAddedServicesItem.link}
              target="_blank"
              onClick={() => this.handleClick(valueAddedServicesItem.icon)}
            >
              {getValueAddedServicesIcon(valueAddedServicesItem.icon)}
              {valueAddedServicesItem.title}
            </a>
          );
        })}
      </div>
    );
  }

  private handleClick = (name: string) => {
    const ACTION_NAME_MAP: { [i: string]: TTrackingAction } = {
      isColorized: TrackingAction.Color,
      isPaid: TrackingAction.Paid,
      isTop3: TrackingAction.Top3,
      isPremium: TrackingAction.Premium,
    };

    const action = ACTION_NAME_MAP[name];

    if (action) {
      trackClick(action);
    }
  };

  private getValueAddedServices = () => {
    if (!this.props.valueAddedServices) {
      return [];
    }

    const { isMlSearchEnabled } = this.props;

    const { isPaid, isPremium, ...otherValueAddedServices } = this.props.valueAddedServices;
    const mainAddedServicesEnabled = [];

    // Премиум и платное всегда идут первые
    if (isPremium) {
      mainAddedServicesEnabled.push({
        icon: 'isPremium',
        link: '/promo/adv/#premium',
        title: 'Премиум',
      });
    }

    if (isPaid) {
      mainAddedServicesEnabled.push({
        icon: 'isPaid',
        link: '/help/add/paid/',
        title: 'Платное',
      });
    }

    // tslint:disable-next-line:max-line-length
    const otherValueAddedServicesEnabled = Object.keys(otherValueAddedServices).reduce(
      (acc, valueAddedServicesKey: keyof typeof otherValueAddedServices) => {
        if (valueAddedServicesKey === 'isFree') {
          return acc;
        }

        const mapValueAddedServicesKeys = isMlSearchEnabled
          ? mapValueAddedMLSearchServicesKeysToString
          : mapValueAddedServicesKeysToString;

        if (otherValueAddedServices[valueAddedServicesKey]) {
          acc.push({
            icon: valueAddedServicesKey,
            link: mapValueAddedServicesKeys[valueAddedServicesKey].link,
            title: mapValueAddedServicesKeys[valueAddedServicesKey].title,
          });
        }

        return acc;
      },
      [] as IOtherValueAddedServicesEnabled[],
    );

    return mainAddedServicesEnabled.concat(otherValueAddedServicesEnabled);
  };
}
